import { createSlice } from "@reduxjs/toolkit";

const pincodeSetupSlice = createSlice({
    name: "pincodeSetup",
    initialState: {
        forgotPincodeToken: null
    },
    reducers: {
      setToken: (state, action) => {
        state.forgotPincodeToken = action?.payload
      },
      removeToken: (state, action) => {
        state.forgotPincodeToken = action?.payload
      },
      clearPincode: (state, action) => {
        state.forgotPincodeToken = null
      }
    }
  });


// this is for dispatch
export const { setToken, removeToken, clearPincode } = pincodeSetupSlice.actions;

// this is for configureStore
export default pincodeSetupSlice.reducer;